

export class SelectApplicationMenuForUserGroupOutputData implements ISelectApplicationMenuForUserGroupOutputData {
    /** The auto-generated id of the tbl_application_sub_menu */
    application_sub_menu_id!: number;
    /** The main menu name with 100 character limit */
    menu_name!: string;
    /** The main menu name with 100 character limit */
    sub_menu_name!: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screen_type!: string;
    no_access!: number;
    view!: number;
    modify!: number;

    constructor(data?: ISelectApplicationMenuForUserGroupOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application_sub_menu_id = _data["application_sub_menu_id"];
            this.menu_name = _data["menu_name"];
            this.sub_menu_name = _data["sub_menu_name"];
            this.screen_type = _data["screen_type"];
            this.no_access = _data["no_access"];
            this.view = _data["view"];
            this.modify = _data["modify"];
        }
    }

    static fromJS(data: any): SelectApplicationMenuForUserGroupOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new SelectApplicationMenuForUserGroupOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application_sub_menu_id"] = this.application_sub_menu_id;
        data["menu_name"] = this.menu_name;
        data["sub_menu_name"] = this.sub_menu_name;
        data["screen_type"] = this.screen_type;
        data["no_access"] = this.no_access;
        data["view"] = this.view;
        data["modify"] = this.modify;
        return data; 
    }
}

export interface ISelectApplicationMenuForUserGroupOutputData {
    /** The auto-generated id of the tbl_application_sub_menu */
    application_sub_menu_id: number;
    /** The main menu name with 100 character limit */
    menu_name: string;
    /** The main menu name with 100 character limit */
    sub_menu_name: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screen_type: string;
    no_access: number;
    view: number;
    modify: number;
}

